import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { isObject } from 'vega-util';
import { normalizeEncoding } from '../encoding';
import { isMarkDef } from '../mark';
import { isUnitSpec } from '../spec/unit';
import { stack } from '../stack';
import { keys, omit, pick } from '../util';

function dropLineAndPoint(markDef) {
  var _point = markDef.point,
      _line = markDef.line,
      mark = __rest(markDef, ["point", "line"]);

  return keys(mark).length > 1 ? mark : mark.type;
}

function dropLineAndPointFromConfig(config) {
  for (var _i = 0, _arr = ['line', 'area', 'rule', 'trail']; _i < _arr.length; _i++) {
    var mark = _arr[_i];

    if (config[mark]) {
      config = Object.assign(Object.assign({}, config), _defineProperty({}, mark, omit(config[mark], ['point', 'line'])));
    }
  }

  return config;
}

function getPointOverlay(markDef) {
  var markConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var encoding = arguments.length > 2 ? arguments[2] : undefined;

  if (markDef.point === 'transparent') {
    return {
      opacity: 0
    };
  } else if (markDef.point) {
    // truthy : true or object
    return isObject(markDef.point) ? markDef.point : {};
  } else if (markDef.point !== undefined) {
    // false or null
    return null;
  } else {
    // undefined (not disabled)
    if (markConfig.point || encoding.shape) {
      // enable point overlay if config[mark].point is truthy or if encoding.shape is provided
      return isObject(markConfig.point) ? markConfig.point : {};
    } // markDef.point is defined as falsy


    return undefined;
  }
}

function getLineOverlay(markDef) {
  var markConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (markDef.line) {
    // true or object
    return markDef.line === true ? {} : markDef.line;
  } else if (markDef.line !== undefined) {
    // false or null
    return null;
  } else {
    // undefined (not disabled)
    if (markConfig.line) {
      // enable line overlay if config[mark].line is truthy
      return markConfig.line === true ? {} : markConfig.line;
    } // markDef.point is defined as falsy


    return undefined;
  }
}

export var PathOverlayNormalizer = /*#__PURE__*/function () {
  function PathOverlayNormalizer() {
    _classCallCheck(this, PathOverlayNormalizer);

    this.name = 'path-overlay';
  }

  _createClass(PathOverlayNormalizer, [{
    key: "hasMatchingType",
    value: function hasMatchingType(spec, config) {
      if (isUnitSpec(spec)) {
        var mark = spec.mark,
            encoding = spec.encoding;
        var markDef = isMarkDef(mark) ? mark : {
          type: mark
        };

        switch (markDef.type) {
          case 'line':
          case 'rule':
          case 'trail':
            return !!getPointOverlay(markDef, config[markDef.type], encoding);

          case 'area':
            return (// false / null are also included as we want to remove the properties
              !!getPointOverlay(markDef, config[markDef.type], encoding) || !!getLineOverlay(markDef, config[markDef.type])
            );
        }
      }

      return false;
    }
  }, {
    key: "run",
    value: function run(spec, normParams, normalize) {
      var config = normParams.config;

      var params = spec.params,
          projection = spec.projection,
          mark = spec.mark,
          e = spec.encoding,
          outerSpec = __rest(spec, ["params", "projection", "mark", "encoding"]); // Need to call normalizeEncoding because we need the inferred types to correctly determine stack


      var encoding = normalizeEncoding(e, config);
      var markDef = isMarkDef(mark) ? mark : {
        type: mark
      };
      var pointOverlay = getPointOverlay(markDef, config[markDef.type], encoding);
      var lineOverlay = markDef.type === 'area' && getLineOverlay(markDef, config[markDef.type]);
      var layer = [Object.assign(Object.assign({}, params ? {
        params: params
      } : {}), {
        mark: dropLineAndPoint(Object.assign(Object.assign({}, markDef.type === 'area' && markDef.opacity === undefined && markDef.fillOpacity === undefined ? {
          opacity: 0.7
        } : {}), markDef)),
        // drop shape from encoding as this might be used to trigger point overlay
        encoding: omit(encoding, ['shape'])
      })]; // FIXME: determine rules for applying selections.
      // Need to copy stack config to overlayed layer

      var stackProps = stack(markDef, encoding);
      var overlayEncoding = encoding;

      if (stackProps) {
        var stackFieldChannel = stackProps.fieldChannel,
            offset = stackProps.offset;
        overlayEncoding = Object.assign(Object.assign({}, encoding), _defineProperty({}, stackFieldChannel, Object.assign(Object.assign({}, encoding[stackFieldChannel]), offset ? {
          stack: offset
        } : {})));
      }

      if (lineOverlay) {
        layer.push(Object.assign(Object.assign({}, projection ? {
          projection: projection
        } : {}), {
          mark: Object.assign(Object.assign({
            type: 'line'
          }, pick(markDef, ['clip', 'interpolate', 'tension', 'tooltip'])), lineOverlay),
          encoding: overlayEncoding
        }));
      }

      if (pointOverlay) {
        layer.push(Object.assign(Object.assign({}, projection ? {
          projection: projection
        } : {}), {
          mark: Object.assign(Object.assign({
            type: 'point',
            opacity: 1,
            filled: true
          }, pick(markDef, ['clip', 'tooltip'])), pointOverlay),
          encoding: overlayEncoding
        }));
      }

      return normalize(Object.assign(Object.assign({}, outerSpec), {
        layer: layer
      }), Object.assign(Object.assign({}, normParams), {
        config: dropLineAndPointFromConfig(config)
      }));
    }
  }]);

  return PathOverlayNormalizer;
}();